import React from 'react';
const WeightSlider = ({
    size,
    sliderColor,
    obj,
    weightChange,
    id,
    index,
    changeMade,
    readOnly
}) => {
    const mouseDown = (e) => {
        if (!readOnly) {
            document.addEventListener('mousemove', mouseMove);
            document.addEventListener('mouseup', mouseUp);
        }
    };
    const mouseMove = (e) => {
        if (!readOnly) {
            if (e.target.className === 'weightSliderBody') {
                let newWeight = Math.round((e.offsetX / 4) * 2, 0);

                if (newWeight > 200) newWeight = 200;
                e.target.closest('.weightInput')?.setAttribute('weight', newWeight);
                obj.weight = newWeight;
                console.log('daye', e);
                obj.percentage = (newWeight / 100) * obj.basePercentage;
                weightChange();
            }
        }
    };
    const mouseUp = (e) => {
        document.removeEventListener('mousemove', mouseMove);
        document.removeEventListener('mouseup', mouseUp);
        if (!readOnly) changeMade();
    };

    return (
        <div style={{ display: 'flex' }}>
            <div
                style={{
                    border: readOnly
                        ? '1px solid #D7D7D7'
                        : '1px solid #FD9A00',
                    width: 400,
                    margin: 1,
                    height: 40,
                    position: 'relative',

                    verticalAlign: 'center',
                    backgroundColor: readOnly ? '#F7F7F7' : '#fffdf4',
                    cursor: readOnly ? 'default' : 'pointer',
                    display: 'flex',
                    padding: 0
                }}
                id={id}
                className='weightSliderBody'
                index={index}
                onMouseDown={mouseDown}
            >
                <div
                    style={{
                        width: obj.weight / 2 + '%',
                        height: '100%',
                        backgroundColor: sliderColor,
                        border: 'blue',
                        float: 'left',
                        pointerEvents: 'none'
                    }}
                ></div>
                <div
                    style={{
                        position: 'absolute',
                        width: 8,
                        height: 8,
                        border: '1px solid #979797',
                        left: 'calc( ' + obj.weight / 2 + '%' + ' - 4px)',
                        top: 18,
                        backgroundColor: 'white',
                        boxSizing: 'border-box',
                        pointerEvents: 'none'
                    }}
                ></div>
            </div>
        </div>
    );
};
export default WeightSlider;
